var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase, RestResult } from "@ane/core/lib/services/RestServiceBase";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
class WPSResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.wps);
    __publicField(this, "apiVersion", "2019-11-01-preview");
  }
  getRootExperimentationGroup(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups/root?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  isAuthorizedonEwRestResult(workspaceId, actionname) {
    return __async(this, null, function* () {
      const url = `/workspaces/${workspaceId}/actionauthorized/${actionname}?apiversion=${this.apiVersion}`;
      const result = yield this._get(url);
      if (result.statusCode === 403) {
        return RestResult.fromResult(false, true);
      } else if (result.statusCode === 200) {
        return RestResult.fromResult(true, true);
      }
      return result;
    });
  }
  isAuthorizedRestResult(workspaceId, experimentationGroup, actionname) {
    return __async(this, null, function* () {
      const url = `/workspaces/${workspaceId}/experimentationGroups/${experimentationGroup}/actionauthorized/${actionname}?apiversion=${this.apiVersion}`;
      const result = yield this._get(url);
      if (result.statusCode === 403 || result.statusCode === 404) {
        return RestResult.fromResult(false, true);
      } else if (result.statusCode === 200) {
        return RestResult.fromResult(true, true);
      }
      return result;
    });
  }
  getWPSWorkspaces() {
    return __async(this, null, function* () {
      const address = `/workspace/select-list?api-version=1.0-preview.1`;
      return yield this._get(address);
    });
  }
  getExperimentationGroups(workspaceId) {
    return __async(this, null, function* () {
      var _a;
      const mdsHost = new URL((_a = EnvironmentService.endpoints.mds.url) != null ? _a : "").hostname;
      const workspace = EnvironmentService.getWorkspaceIdOrDefault(workspaceId);
      const address = `/workspace/${workspace}/proxy/${mdsHost}/workspaces/${workspace}/experimentationGroups?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
}
const WPSResource$1 = new WPSResource();
export {
  WPSResource,
  WPSResource$1 as default
};
//# sourceMappingURL=WPSResource.js.map
